import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import LandingHeader from "../components/LandingHeader";
import LandingFooter from "../components/LandingFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>5 Shameless Real Estate Marketing Tricks Guide - courtesy of Elm Street</title>
        <meta
          name="description"
          content="Marketing. Real estate marketing. Organic marketing. Paid advertising. From the Kardashians to Jade Mills of Coldwell Banker, marketing is an integral part of any industry, including the one where you have your real estate business."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/shameless" />
        <meta property="og:title" content="Shameless Guide - courtesy of Elm Street" />
        <meta
          property="og:description"
          content="Marketing. Real estate marketing. Organic marketing. Paid advertising. From the Kardashians to Jade Mills of Coldwell Banker, marketing is an integral part of any industry, including the one where you have your real estate business."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />

      <LandingHeader />

      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h2" component="h1" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                    5 shameless real estate marketing tricks <span style={{ color: "#ffffff" }}>that will satisfy your appetite</span>
                  </span>
                  
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  <strong style={{ color: "#f69c26" }}>
                  ...and why you need to be using them.
                  </strong>
                  <br />
                  <br />
                  Marketing. Real estate marketing. Organic marketing. Paid advertising. From the Kardashians to Jade Mills of Coldwell Banker, marketing is an integral part of any industry, including the one where you have your real estate business. But how do you string them together to create one, concise real estate marketing plan with actionable steps that doesn't take a law degree or deep influencer knowledge to understand? Download this guide to find out!
                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image src="/shameless_cover.jpg" width="700px" height="892px" alt="Shameless cover"/>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ textAlign: "left" }}>
        <div style={{ marginTop: "68px", marginBottom: "68px" }}>
          <Grid container spacing={8} justifyContent="center">
            <Grid item md={8}>
            <DemoForm
              buttonText="Download Now"
              successMsg={<div style={{textAlign:"center"}}><strong>Thank you for your interest!</strong><br/><br/><Button variant="contained" color="secondary" href="/assets/es-shameless.pdf">Download the PDF</Button></div>}
              formName="es2_shameless" listId="148012"
              fieldList={["first_name", "last_name", "email", "phone", "roll"]}
            />
            </Grid>
          </Grid>
        </div>
      </Container>

      <LandingFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
